enum LoginFieldType {
    Email = 'Email',
    PhoneNumber = 'PhoneNumber',
    LastName = 'LastName',
    Zip = 'Zip',
    FirstName = 'FirstName',
}

export default LoginFieldType;
